import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface ComicCardProps {
  id: string;
  title: string;
  cover: string;
  categoryName: string;
  status: string;
  chapters: number;
  rating: number;
  badge?: string;
}

export function ComicCard({ id, title, cover, categoryName, status, chapters, rating, badge }: ComicCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-accent-300/60 cursor-pointer"
    >
      <div className="relative">
        {badge && (
          <span className="absolute top-2 left-2 z-10 px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            {badge}
          </span>
        )}
        <div className="w-full aspect-[3/4] overflow-hidden">
          <img
            src={cover}
            alt={title}
            title={`${title} - 51漫画在线免费阅读`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 truncate">{title}</h3>
        <div className="flex items-center justify-between mt-1.5">
          <span className={`text-xs px-1.5 py-0.5 rounded ${
            status === '连载中' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
          }`}>
            {status}
          </span>
          <span className="text-xs text-foreground-500">{chapters}话</span>
        </div>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-400">{categoryName}</span>
          <span className="text-xs text-accent-500 flex items-center gap-0.5">
            <i className="ri-star-fill text-[10px]"></i> {rating}
          </span>
        </div>
      </div>
    </Link>
  );
}

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function SectionHeader({ title, subtitle, action }: SectionHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6 md:mb-8">
      <div>
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900">{title}</h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}